import React, { createContext, useContext } from "react";
import { User } from "../models/user";
import { useConfigContext } from "./ConfigContext";
import { useUser } from "../hooks/useUser";
import { OtpMethod } from "../models/otp-methods";

type UserContextValue = {
	user: User | null;
	setUser: React.Dispatch<React.SetStateAction<User | null>>;
	onLogout: (otpMethod: OtpMethod) => Promise<boolean>;
	isLoading: boolean;
	isLoggingOut: boolean;
};

const UserContext = createContext<UserContextValue | undefined>(undefined);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	const { config } = useConfigContext();
	const { user, setUser, onLogout, isLoading, isLoggingOut } =
		useUser(config);

	return (
		<UserContext.Provider
			value={{
				user,
				setUser,
				onLogout,
				isLoading,
				isLoggingOut,
			}}
		>
			{children}
		</UserContext.Provider>
	);
};

export function useUserContext() {
	const context = useContext(UserContext);
	if (!context) {
		throw new Error("useUserContext must be used within a UserProvider");
	}
	return context;
}
